module.exports = __webpack_public_path__ + "img/1x.0453a3d6.png";